import { DataBox, createDataBox, createDataBoxDefault } from 'app/common/data-box-store'
import { ItemType } from 'app/common/ui-next/plain-selector'


export enum FoodType {
  Hot = 'hot'
}

export type FoodTypes = Array<ItemType>

class FoodTypesFilterDataBox extends DataBox<FoodTypes> { }

export const defaultFoodTypes: FoodTypes = []
export const foodTypesFilter = createDataBox('foodTypesFilter', defaultFoodTypes, FoodTypesFilterDataBox)

export const defaultFoodTypesData = () => {
  return [{
    id: FoodType.Hot,
    title: 'Горячее питание',
  }]
}

foodTypesFilter.updateData(defaultFoodTypesData)
foodTypesFilter.setStatusReady()

export const defaultFoodTypesSelection: Array<string> = [FoodType.Hot]
export const foodTypesFilterSelection = createDataBoxDefault<Array<string>>('foodTypesSelection', defaultFoodTypesSelection)
